import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class SubscriptionActiveFeatures extends Model {
  [Type] = 'subscription/active-features' as const;

  @attr() declare features: string[];
}
